var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}],staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.loader,"z-index":"9999"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}}),_c('br'),_vm._v(" Cargando..."),_c('br'),_vm._v(" Este proceso puede durar unos segundos.... ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }